export default "__VITE_ASSET__58UgALQ0__"